﻿import { getTranslations } from "../../translations";
import { sendApiCall } from "../../utilities/api";
import { loaderIconButton, resetLoaderButton } from "../../utilities/loaderIconButton";
import { Popup, PopupButton } from "../../utilities/popup";
import { sendDataLayer } from "../../components/ecommerce/ecommerce";
import { refreshKeyboardInteractions } from "../../helpers";
import { getActiveFilters } from "../../components/category";
import { renderTemplate } from "../../utilities/cms.TemplateEngine";
import { getTemplate } from "../../utilities/templates";
import { getURLWithoutFilters, loadTrackablePage } from "./filter";

document.addEventListener("DOMContentLoaded", () =>
{
    new FilterWizard();
});

export class FilterWizard
{
    filterWizard: FilterWizard = this;
    popup: Popup;
    filterModalOpen: boolean;

    selectedDict = {};
    deSelectedCheckBoxDict = {};
    stepsViewed = [];
    infoFilterUrl = null;
    infoFilterOptions = null;
    infoPassedProperties = null;
    currentResultOptions = null;
    buildWizard = '';
    buildWizardPrice = '';
    buildFilterUrl = '';
    filterPopupDoubleClick = false;
    filterPopupDoubleClickID = 0;
    filterInfoCall = null;
    filterResultCount: number = 0;
    scrollLimiter = null;
    filterModalTimeout = null;
    wizardEventsSet: boolean;
    applyingFilterFromWizard: boolean;

    // Template
    wizardIntroHtml = getTemplate("filterwizard.introduction.html");
    wizardStepHtml = getTemplate("filterwizard.step.html");
    wizardOptionColorHtml = getTemplate("filterwizard.step.option.color.html");
    wizardOptionColorMultiHtml = getTemplate("filterwizard.step.option.color.multi.html");
    wizardOptionHtml = getTemplate("filterwizard.step.option.html");
    wizardImageHtml = getTemplate("filterwizard.step.option.image.html");
    wizardTitle: string;

    constructor()
    {
        const buttons = document.querySelectorAll(".js-filter-wizard:not(.is-init)");
        if (buttons)
        {
            this.checkVisibility();

            buttons.forEach((btn, index) =>
            {
                btn.classList.add("is-init");
                $(btn).off("click");
                $(btn).on("click", (event) =>
                {
                    this.filterWizardClick(btn);
                });
            });

            this.checkHash();
        }
    }

    // #region Init methods

    private checkVisibility()
    {
        var wizardfilterblock = $(".js-filter-wizard");
        if (wizardfilterblock.length > 0)
        {
            // Get filter list (excluding price filters).            
            const filterList = $(".j-filter__list .j-filter__list-item[data-property-id!=\"price\"]");

            // Check if we have any filters left other than price
            if (typeof filterList === "undefined" || filterList == null || filterList.length <= 0)
                // No filters, meaning the filterwizard modal would be empty; hide.
                $(wizardfilterblock).addClass('hidden');
            else
                $(wizardfilterblock).removeClass('hidden');
        }
    }

    private checkHash()
    {
        var hash = document.location.hash;
        if (hash.indexOf('keuzehulp') >= 0)
        {
            // Remove keuzehulp hash
            if (hash == "#keuzehulp")
                history.pushState("", document.title, window.location.pathname + window.location.search);

            if ($(".js-filter-wizard").length > 0)
            {
                const wizardfilterblock = $(".js-filter-wizard").data("id");
                if (wizardfilterblock)
                    $(".js-filter-wizard")[0].click();
            }
        }
    }

    // #endregion Init methods

    // #region events

    private filterWizardClick(btn)
    {
        this.initPopup(btn);
        this.show();
    }

    // #endregion events

    private initPopup(filterwizardblock)
    {
        if (this.filterModalOpen)
            return;

        const instance = this;
        this.selectedDict = {};
        this.deSelectedCheckBoxDict = {};
        this.stepsViewed = [];

        sendDataLayer({
            'category': 'navigatie',
            'action': 'Keuzehulp',
            'label': document.location.pathname,
            'event': 'Click'
        });

        const wizardID = $(filterwizardblock).data("id");

        // Retrieve the wizard information
        var resetUIblock = true;

        this.infoFilterUrl = null;
        this.currentResultOptions = null;
        this.infoFilterOptions = null;
        this.infoPassedProperties = new Array();

        // Get filter wizard properties and active filter properties.
        var wizardProperties = $(filterwizardblock).data("properties");

        var currentFilterProperties = getActiveFilters(true, false, false, false);

        var currentFilterPropertyIDs = null;

        // Store filter wizard and active filter properties in arrays.
        var wizardPropertiesArray = [];
        var currentFilterPropertiesArray = [];

        if (typeof currentFilterProperties !== typeof (undefined) &&
            currentFilterProperties != null &&
            currentFilterProperties.length > 0)
        {
            // Get unique property IDs from array, and create comma-separated list from them.
            currentFilterPropertyIDs = currentFilterProperties
                .map(x => x[0])
                .filter((value, index, self) => self.indexOf(value) == index)
                .join();
        }

        var json = [];
        // Add filter wizard properties and active filter properties as parameters.
        var propertyParams = "";

        if (typeof wizardProperties !== typeof (undefined) && wizardProperties != null && wizardProperties.length > 0)
        {
            propertyParams += "&wizardproperties=" + wizardProperties;
            json.push({ 'wizardproperties': wizardProperties });
            wizardPropertiesArray = wizardProperties.split(",");
        }

        if (typeof currentFilterPropertyIDs !== typeof (undefined) && currentFilterPropertyIDs != null && currentFilterPropertyIDs.length > 0)
        {
            propertyParams += "&activeproperties=" + currentFilterPropertyIDs;
            json.push({ 'activeproperties': wizardProperties });
            currentFilterPropertiesArray = currentFilterPropertyIDs.split(",");
        }

        var callBack = function (data, statusText, jqXHR)
        {
            resetUIblock = false;
            this.buildWizard = '';
            this.buildWizardPrice = '';
            this.filterResultCount = 0;

            if (jqXHR.status !== 200)
                return;

            var result = '';
            if (typeof (data.d) !== typeof (undefined))
                result = data.d;
            else if (typeof (data) !== typeof (undefined))
            {
                instance.wizardTitle = data.description;

                if (data.showIntroduction)
                {
                    const wizardTE = [];
                    wizardTE.push({ "image": data.image });
                    wizardTE.push({ "description": data.description });
                    wizardTE.push({ "button_text": data.buttonText });
                    wizardTE.push({ "title": data.title });
                    wizardTE.push({ "wizardID": data.id });

                    result = renderTemplate(wizardTE, instance.wizardIntroHtml);
                }
                else
                {
                    var stepTE = [];

                    var steps = [];
                    var currentStep;
                    data.steps.forEach(function (item, index)
                    {
                        var step = [];
                        step["title"] = item.title;
                        step["extra_class"] = item.extraClass;
                        step["headerText"] = item.headerText;
                        step["propertyID"] = item.propertyID;
                        step["priority"] = item.priority;
                        step["order"] = item.order;
                        steps.push(step);
                        if (item.order === data.currentStep + 1)
                            currentStep = item;
                    });

                    stepTE.push({ "amountPerRow": data.amountPerRow });
                    stepTE.push({ "steps": steps });

                    var renderedOptions = '';

                    if (typeof (data.options) !== typeof (undefined) &&
                        data.options != null)
                    {
                        data.options.forEach(function (item, index)
                        {
                            var template;
                            var optionTE = [];
                            if (currentStep.stepType === 1 && item.image !== null) // TextWithImage
                            {
                                template = instance.wizardImageHtml;
                                optionTE.push({ "image": item.image });
                            }
                            else if (item.stepType === 2) // Color
                            {
                                if (item.colorCode === "#multi")
                                {
                                    template = instance.wizardOptionColorMultiHtml;
                                    optionTE.push({ "colorImageLocation": item.colorImageLocation });
                                }
                                else
                                {
                                    template = instance.wizardOptionColorHtml;
                                    optionTE.push({ "colorImage": "none" });
                                }
                            }
                            else // Option
                                template = instance.wizardOptionHtml;

                            optionTE.push({ "title": item.title });
                            optionTE.push({ "description": item.description });
                            optionTE.push({ "colorCode": item.colorCode });
                            optionTE.push({ "optionID": item.searchNameID });

                            renderedOptions += renderTemplate(optionTE, template);
                        });
                    }

                    stepTE.push({ "options": renderedOptions });
                    stepTE.push({ "title": data.title });
                    stepTE.push({ "description": data.description });
                    stepTE.push({ "button_text": data.buttonText });
                    stepTE.push({ "propertyID": data.propertyID });
                    stepTE.push({ "wizardID": data.id });
                    stepTE.push({ "currentStep": data.currentStep });
                    stepTE.push({ "nextStep": data.nextStep });

                    result = renderTemplate(stepTE, instance.wizardStepHtml);
                }
            }
            const buttonList = [];

            // previous button

            const btnPrevious = new PopupButton();
            btnPrevious.className = "btn btn-arrow-left btn-loader previousStep";
            btnPrevious.label = getTranslations().txtPrevious;
            btnPrevious.closeOnCLick = false;
            buttonList.push(btnPrevious);

            // show button
            const btnShow = new PopupButton();
            btnShow.className = "btn btn-green show-results";
            btnShow.label = getTranslations().txtFilterShowAllResult;
            buttonList.push(btnShow);

            // skip button
            const btnSkip = new PopupButton();
            btnSkip.className = "btn btn-pink btn-loader btn-arrow-right nextStep";
            btnSkip.label = getTranslations().txtSkip;
            btnSkip.closeOnCLick = false;
            buttonList.push(btnSkip);

            const closeButton = new PopupButton();
            closeButton.closeOnCLick = true;
            closeButton.onClick = () =>
            {
                instance.popup.destroy();
            };

            instance.popup = new Popup({
                id: "wizard-modal",
                buttons: buttonList,
                title: instance.wizardTitle,
                closeButton: closeButton,
                content: result,
                onHide: () =>
                {
                    instance.popup.destroy();
                },
                popupClass: "g-popup__container--w-480"
            });

            instance.popup.show();

            var activeStepPropertyID = $("#modal-wizard-modal .modal-content .wizard-step-item.selected").data("property-id");

            if (typeof instance.infoPassedProperties === typeof (undefined) || instance.infoPassedProperties == null)
                instance.infoPassedProperties = new Array();

            if (typeof instance.infoFilterOptions === typeof (undefined) || instance.infoFilterOptions == null)
                instance.infoFilterOptions = new Array();

            var wizardHashFilter = "";

            // Loop filter wizard properties; for each property that is not the active step property,
            // store the selected filter property options.
            $(wizardPropertiesArray).each((index, propertyID) =>
            {
                if (propertyID != activeStepPropertyID)
                {
                    if (!instance.infoPassedProperties.includes(propertyID))
                        instance.infoPassedProperties.push(propertyID);

                    if (typeof instance.infoFilterOptions[propertyID] === typeof (undefined))
                        instance.infoFilterOptions[propertyID] = new Array();

                    // Get active filter property options for given property.
                    var activeFilterPropertyOptions = currentFilterProperties
                        .filter(function (item) { return item[0] == propertyID })
                        .map(x => x[1]);

                    if (activeFilterPropertyOptions.length > 0)
                    {
                        $(activeFilterPropertyOptions).each(function (index, optionID)
                        {
                            instance.infoFilterOptions[propertyID].push(optionID);
                        });
                    }
                }
                else
                    return false;
            });

            // Add all active property filters to wizard hash filter.
            $(currentFilterPropertiesArray).each(function (index, propertyID)
            {
                // Get active filter property options for given property.
                var activeFilterPropertyOptions = currentFilterProperties
                    .filter(function (item) { return item[0] == propertyID })
                    .map(x => x[1]);

                if (activeFilterPropertyOptions.length > 0)
                {
                    $(activeFilterPropertyOptions).each(function (index, optionID)
                    {
                        if (wizardHashFilter.length <= 0)
                            wizardHashFilter += "#";
                        else
                            wizardHashFilter += "_";

                        wizardHashFilter += propertyID + "-" + optionID;
                    });
                }
            });

            // Get all active price filters.
            var currentPriceFilters = getActiveFilters(false, false, true, false);

            // Set any active price filters.
            if (typeof currentPriceFilters !== typeof (undefined) && currentPriceFilters != null && currentPriceFilters.length > 0)
            {
                $(currentPriceFilters).each(function (index, value)
                {
                    if (instance.buildWizardPrice.length <= 0)
                        instance.buildWizardPrice += "?";
                    else
                        instance.buildWizardPrice += "&";

                    var sliderProperty = currentPriceFilters[index][0];
                    var sliderValue = currentPriceFilters[index][1];

                    instance.buildWizardPrice += sliderProperty + "=" + sliderValue;
                });
            }

            var hasFiltersActive = currentFilterPropertiesArray.length > 0 && wizardHashFilter.length > 0;
            var hasPriceFiltersActive = instance.buildWizardPrice.length > 0;

            // Apply wizard- and price filters upon opening if any should be set.
            // Also fixes issue where result count may not count trackable filter if the property is not from the first step.         
            if (hasFiltersActive || hasPriceFiltersActive)
            {
                if (hasFiltersActive)
                    instance.buildWizard = "/" + getURLWithoutFilters() + "/" + wizardHashFilter;

                instance.selectWizardFilters(false, false);
            }

            // attach new events
            if ($("#modal-wizard-modal .wizard-introduction-button") && $("#modal-wizard-modal .wizard-introduction-button").length > 0)
            {
                $("#modal-wizard-modal .wizard-introduction-button").on("click", function (event)
                {
                    //new LoaderIconButton({ button: this as HTMLButtonElement }).show();
                    $("#modal-wizard-modal .wizard-introduction-button").off("click");

                    var currentStep = instance.getCurrentStep();
                    var currentWizard = instance.getCurrentWizardID();
                    var nextStep = instance.getNextStep();
                    var propertyID = instance.getPropertyID();

                    if ((currentStep + 1) == nextStep)
                    {
                        instance.infoPassedProperties.push(propertyID);

                        instance.updateDisabledOptions(function (event)
                        {
                            instance.loadFilterWizardStep(currentWizard, nextStep);
                        });
                    }
                });
            }
            else
            {
                instance.addWizardStepEvents();

                refreshKeyboardInteractions();
            }
        };

        if (shopConfig().api.active)
        {
            json.push({ 'wizardid': wizardID });
            sendApiCall({ endpoint: '/Filter/GetWizardStep', rawUrl: location.pathname, qsDictionary: json, callback: callBack });
        }
        else
        {
            // Execute the ajax call to retrieve the content
            $.ajax({
                type: "POST",
                url: "/Services/Modules/Webshop.asmx/GetWizardStep?initial=1&wizardid=" + wizardID + propertyParams,
                contentType: "application/json; charset=utf-8",
                dataType: "json",
                success: callBack
            });
        }

        this.filterModalTimeout = setTimeout(function ()
        {
            if (resetUIblock)
            {
                instance.close();
            }
        }, 10000);
    }

    // #region Steps

    private getCurrentStep(): number
    {
        return parseInt($("#currentWizardStep")?.val()?.toString() ?? "0");
    }

    private getPreviousStep(): number
    {
        return this.getCurrentStep() - 1;
    }

    private getNextStep(): number
    {
        return parseInt($("#nextWizardStep")?.val()?.toString() ?? "0");
    }

    private getCurrentWizardID(): number
    {
        return parseInt($("#currentWizardID")?.val()?.toString() ?? "0");
    }

    private getPropertyID(): number
    {
        return parseInt($("#currentWizardProperty")?.val()?.toString() ?? "0");
    }

    // #endregion steps

    private loadFilterWizardStep = (wizardID, currentStep) =>
    {
        const instance = this;
        var callBack = function (data, statusText, jqXHR)
        {
            var result = '';
            if (typeof (data.d) !== typeof (undefined))
                result = data.d;
            else if (typeof (data) !== typeof (undefined))
            {
                instance.wizardTitle = data.description;
                if (data.showIntroduction)
                {
                    var dataDescription = "";

                    if (typeof (data.description) !== typeof (undefined) &&
                        data.description != null &&
                        data.description.length > 0
                    )
                        dataDescription = data.description;

                    var wizardTE = [];
                    wizardTE.push({ "image": data.image });
                    wizardTE.push({ "description": dataDescription });
                    wizardTE.push({ "button_text": data.buttonText });
                    wizardTE.push({ "title": data.title });
                    wizardTE.push({ "wizardID": data.id });

                    result = renderTemplate(wizardTE, this.wizardIntroHtml);
                }
                else
                {
                    var stepTE = [];

                    var steps = [];
                    var currentStep;
                    data.steps.forEach(function (item, index)
                    {
                        var step = [];
                        step["title"] = item.title;
                        step["extra_class"] = item.extraClass;
                        step["headerText"] = item.headerText;
                        step["propertyID"] = item.propertyID;
                        step["priority"] = item.priority;
                        step["order"] = item.order;
                        steps.push(step);
                        if (item.order === data.currentStep + 1)
                            currentStep = item;
                    });

                    stepTE.push({ "amountPerRow": data.amountPerRow });
                    stepTE.push({ "steps": steps });

                    var renderedOptions = '';

                    if (typeof (data.options) !== typeof (undefined) &&
                        data.options != null)
                    {
                        data.options.forEach(function (item, index)
                        {
                            var template;
                            var optionTE = [];
                            if (currentStep.stepType === 1 && item.image !== null) // TextWithImage
                            {
                                template = instance.wizardImageHtml;
                                optionTE.push({ "image": item.image });
                            }
                            else if (currentStep.stepType === 2) // Color
                            {
                                if (item.colorCode === "#multi")
                                {
                                    template = instance.wizardOptionColorMultiHtml;
                                    optionTE.push({ "colorImageLocation": item.colorImageLocation });
                                }
                                else
                                {
                                    template = instance.wizardOptionColorHtml;
                                    optionTE.push({ "colorImage": "none" });
                                }
                            }
                            else if (currentStep.stepType === 3) // TextOnly
                                template = instance.wizardOptionHtml;
                            else // Option
                                template = instance.wizardOptionHtml;

                            var itemDescription = "";

                            if (typeof (item.description) !== typeof (undefined) &&
                                item.description != null &&
                                item.description.length > 0
                            )
                                itemDescription = item.description;

                            optionTE.push({ "title": item.title });
                            optionTE.push({ "description": itemDescription });
                            optionTE.push({ "colorCode": item.colorCode });
                            optionTE.push({ "optionID": item.searchNameID });
                            optionTE.push({ "steptype": item.stepTypeName });

                            renderedOptions += renderTemplate(optionTE, template);
                        });
                    }

                    stepTE.push({ "options": renderedOptions });
                    stepTE.push({ "title": data.title });
                    stepTE.push({ "description": data.description });
                    stepTE.push({ "button_text": data.buttonText });
                    stepTE.push({ "propertyID": data.propertyID });
                    stepTE.push({ "wizardID": data.id });
                    stepTE.push({ "currentStep": data.currentStep });
                    stepTE.push({ "nextStep": data.nextStep });

                    result = renderTemplate(stepTE, instance.wizardStepHtml);
                }
            }

            instance.popup.updateTitle(instance.wizardTitle);
            instance.popup.updateContent(result);

            if (typeof (instance.selectedDict) != typeof (undefined))
            {
                // Select user chosen items
                $.each(instance.selectedDict, function (index, item)
                {
                    $(item).each(function (i, value)
                    {
                        $(".c-filterwizard__option[data-property='" + index + "'][data-option='" + value + "']").addClass('is-selected');
                        $(".c-filterwizard-option__color[data-property='" + index + "'][data-option='" + value + "']").addClass('is-selected');
                    })
                });

                instance.updateNextStepButtonText();
            }

            instance.addWizardStepEvents();
            resetLoaderButton($("#modal-wizard-modal .nextStep")[0]);
            resetLoaderButton($("#modal-wizard-modal .previousStep")[0]);
            refreshKeyboardInteractions();
        };

        if (shopConfig().api.active)
        {
            var json = [];
            json.push({ 'wizardid': wizardID });
            json.push({ 'step': currentStep });
            sendApiCall({ endpoint: '/Filter/GetWizardStep', rawUrl: location.pathname, qsDictionary: json, callback: callBack });
        }
        else
        {
            $.ajax({
                type: "POST",
                url: "/Services/Modules/Webshop.asmx/GetWizardStep?initial=0&wizardid=" + wizardID + "&step=" + currentStep,
                contentType: "application/json; charset=utf-8",
                dataType: "json",
                success: callBack
            });
        }
    };

    private addWizardStepEvents()
    {
        const instance = this;
        var currentStep = this.getCurrentStep();

        // check for already selected options
        $(".wizard-option, .c-filterwizard__option, .c-filterwizard-option__color").each(function (index, item)
        {
            var option = $(item);
            var propertyID = $(option).data("property");
            var optionID = $(option).data("option");

            var checkbox = $("[data-id=chk-" + propertyID + "-" + optionID + "]");

            var isCheckboxDeselected = typeof (instance.deSelectedCheckBoxDict[propertyID]) != typeof (undefined);
            var isCheckboxSelected = typeof (instance.selectedDict[propertyID]) != typeof (undefined);

            if (instance.currentResultOptions != null && instance.infoPassedProperties.length > 0)
            {
                if (!instance.currentResultOptions.includes(optionID) && currentStep != 0)
                    $(option).addClass("disabled");
                else if (checkbox && checkbox.length > 0)
                {
                    if (checkbox.prop("checked"))
                    {
                        // Don't toggle if user already (un)checked the item
                        if (
                            $.inArray(currentStep, instance.stepsViewed) == -1 ||
                            (!isCheckboxDeselected || (isCheckboxDeselected && $.inArray(optionID, instance.deSelectedCheckBoxDict[propertyID]) == -1)) &&
                            (!isCheckboxSelected || (isCheckboxSelected && $.inArray(optionID, isCheckboxSelected[propertyID]) != -1)))
                        {
                            instance.toggleWizardOption(option, propertyID, optionID, true);
                        }
                    }
                }
            }
            else
            {
                if (checkbox && checkbox.length > 0)
                {
                    if (checkbox.prop("checked"))
                    {
                        // Don't toggle if user already (un)checked the item
                        if ($.inArray(currentStep, instance.stepsViewed) == -1 ||
                            (!isCheckboxDeselected || (isCheckboxDeselected && $.inArray(optionID, instance.deSelectedCheckBoxDict[propertyID]) == -1)) &&
                            (!isCheckboxSelected || (isCheckboxSelected && $.inArray(optionID, isCheckboxSelected[propertyID]) != -1)))
                        {
                            instance.toggleWizardOption(option, propertyID, optionID, true);
                        }
                    }
                }
                else if (currentStep != 0)
                    $(option).addClass("disabled");
            }
        });

        if ($.inArray(currentStep, instance.stepsViewed) == -1)
            instance.stepsViewed.push(currentStep);

        // Check if any filterwizard property options should be hidden.
        this.setFilterWizardOptionVisibility();

        if ($("#modal-wizard-modal .c-filterwizard-option--image") && $("#modal-wizard-modal .c-filterwizard-option--image").length > 0)
        {
            $("#modal-wizard-modal .c-filterwizard-option--image").off();
            $("#modal-wizard-modal .c-filterwizard-option--image").on("click", function ()
            {
                instance.handleWizardClick(this);
            });
        } else if ($("#modal-wizard-modal .c-filterwizard-option__color") && $("#modal-wizard-modal .c-filterwizard-option__color").length > 0)
        {
            $("#modal-wizard-modal .c-filterwizard__options").addClass("uk-flex");
            $("#modal-wizard-modal .c-filterwizard__options").addClass("uk-flex-center");
            $("#modal-wizard-modal .c-filterwizard__options").addClass("uk-flex-wrap");
            $("#modal-wizard-modal .c-filterwizard__options").addClass("uk-flex-row");

            $("#modal-wizard-modal .c-filterwizard-option__color").off();
            $("#modal-wizard-modal .c-filterwizard-option__color").on("click", function ()
            {
                instance.handleWizardClick(this);
            });
        } else if ($("#modal-wizard-modal .c-filterwizard__option.textonly") && $("#modal-wizard-modal .c-filterwizard__option.textonly").length > 0)
        {
            $("#modal-wizard-modal .c-filterwizard__options").addClass("uk-flex");
            $("#modal-wizard-modal .c-filterwizard__options").addClass("uk-flex-center");
            $("#modal-wizard-modal .c-filterwizard__options").addClass("uk-flex-wrap");

            $("#modal-wizard-modal .c-filterwizard__option.textonly").off();
            $("#modal-wizard-modal .c-filterwizard__option.textonly").on("click", function ()
            {
                instance.handleWizardClick(this);
            });
        } else if ($("#modal-wizard-modal .c-filterwizard__option:not(.textonly)") && $("#modal-wizard-modal .c-filterwizard__option:not(.textonly)").length > 0)
        {
            $("#modal-wizard-modal .c-filterwizard__option:not(.textonly)").off();
            $("#modal-wizard-modal .c-filterwizard__option:not(.textonly)").on("click", function ()
            {
                instance.handleWizardClick(this);
            });
        }

        if ($("#modal-wizard-modal .previousStep").length > 0)
        {
            var previousStep = this.getPreviousStep();

            if (previousStep >= 0)
            {
                $("#modal-wizard-modal .previousStep").off();
                $("#modal-wizard-modal .previousStep").on("click", function ()
                {
                    new loaderIconButton({ button: this as HTMLButtonElement }).show();
                    instance.changeWizardStep(previousStep);
                });
            }
        }

        let initShowResultsButton = true;

        if ($("#modal-wizard-modal .show-results") && $("#modal-wizard-modal .show-results").length > 0)
        {
            var resultText = getTranslations().txtFilterShowAllResult;
            if (this.filterResultCount > 0) {
                resultText = String.format(getTranslations().filterResultText, instance.filterResultCount);
                $(".show-results-holder").show();
                $(".show-results").show();
                $(".show-results").text(resultText);
            } else if (initShowResultsButton) {
                $(".show-results").hide();
                $(".show-results").text(resultText);
            } else {
                $(".show-results").text(resultText);
            }

            $("#modal-wizard-modal .show-results").off();
            $("#modal-wizard-modal .show-results").on("click", function ()
            {
                instance.applyingFilterFromWizard = true;

                $("#modal-wizard-modal button").off("click");
                instance.applyWizardFilters();
                instance.close();
            });
        }

        if ($("#modal-wizard-modal .nextStep").length > 0)
        {
            const nextWizardStep = instance.getNextStep();

            if (nextWizardStep > 0)
            {
                $("#modal-wizard-modal .nextStep").on("click", function ()
                {
                    new loaderIconButton({ button: this as HTMLButtonElement }).show();
                    instance.changeWizardStep(nextWizardStep);
                });
            }
        }

        if ($(".wizard-step-item.selected").length > 0 &&
            $(".wizard-step-item:not(.selected)").length > 0)
        {
            $(".wizard-step-item:not(.selected)").each(function (index, item)
            {
                $(item).on("click", function ()
                {
                    var itemStep = parseInt($(item).data("order")) - 1;

                    if (!isNaN(itemStep))
                    {
                        $(item).find(".step-number").addClass("hidden");
                        $(item).find("img").removeClass("hidden");
                        $(item).find("span").text("");

                        instance.changeWizardStep(itemStep);
                    }
                });
            });
        }

        this.checkWizardStepButtons();
    };

    private setFilterWizardOptionVisibility = () =>
    {
        // Get property ID of currently shown filterwizard step.
        var currentStepProperty = $("#currentWizardProperty").val();

        if (typeof currentStepProperty !== typeof (undefined) &&
            currentStepProperty != null)
        {
            // Get filter list.
            var filterList = $($("ul.filter-list")[0]);

            if (typeof filterList !== typeof (undefined) &&
                filterList != null &&
                filterList.length > 0)
            {
                // Get filter option for current step.
                var filterProperty = $(filterList).find("> li[data-property-id=\"" + currentStepProperty + "\"]");

                if (typeof filterProperty !== typeof (undefined) &&
                    filterProperty != null)
                {
                    // Loop filterwizard step options to hide all options that are disabled on page.
                    $(".c-filterwizard__options > div").each(function (index, item)
                    {
                        // Get current property option ID.
                        var optionID = $(item).data("option");

                        if (typeof optionID !== typeof (undefined) &&
                            optionID != null)
                        {
                            // Check if there is a normal or color filter for the current option.
                            // If not, or it's disabled, hide it.
                            var filterOption = $(filterProperty).find(".options .row[data-value=\"" + optionID + "\"]");

                            if ((typeof filterOption === typeof (undefined) ||
                                filterOption == null ||
                                $(filterOption).length <= 0 ||
                                $(filterOption).data("disabled"))
                            )
                                $(item).hide();
                        }
                    });
                }
            }
        }
    }

    private applyWizardFilters = () =>
    {
        var currentPath = document.location.pathname + document.location.hash;

        if (this.buildWizard.length > 0 && this.buildWizard != currentPath)
        {
            var parts = this.buildWizard.split('#');
            var currentHash = '';

            if (parts.length > 1)
                currentHash = parts[1];

            if (currentHash.length > 0 && !currentHash.startsWith("#"))
                currentHash = "#" + currentHash;

            // Make sure to include active filters that are not listed in the wizardfilter
            var existingHash = document.location.hash;

            var sortedArray = new Array();

            $(".wizard-step-item").each(function (index, item)
            {
                var propertyID = $(item).data('property-id');
                sortedArray.push(propertyID.toString());
            });

            if (existingHash.length > 1)
            {
                if (existingHash.indexOf('#') == 0)
                    existingHash = existingHash.substring(1);

                var propertiesSplit = existingHash.split('_');
                for (var i = 0; i < propertiesSplit.length; i++)
                {
                    var currentProp = propertiesSplit[i].split('-')[0];

                    // only add existing hash if hash property is not listed in the wizard filter
                    if ($.inArray(currentProp, sortedArray) == -1)
                    {
                        if (!currentHash.startsWith("#"))
                            currentHash = "#" + propertiesSplit[i];
                        else if (!currentHash.includes(propertiesSplit[i]))
                            currentHash += "_" + propertiesSplit[i];
                    }
                }
            }

            if (parts[0].length > 0)
            {
                // Only use current if we have at least one property hash
                if (parts[0].includes('-') && !currentHash.includes('-'))
                    currentHash = '';

                this.applyingFilterFromWizard = true;

                loadTrackablePage(
                    parts[0] + this.buildWizardPrice + currentHash,
                    false
                );
            }

            if (currentHash.length > 0)
            {
                setTimeout(function ()
                {
                    document.location.hash = currentHash;
                }, 50);
            }
        }
    }

    private toggleWizardOption = (option, propertyID, optionID, onlyVisual) =>
    {
        var selected = $(option).hasClass("is-selected");

        if (selected)
        {
            $(option).removeClass("is-selected");
            $(option).find("[type=checkbox]").prop("checked", false);
            // keep list of active filters
            var selectedValue = this.selectedDict[propertyID];
            if (typeof (selectedValue) != typeof (undefined))
            {
                if ($.inArray(optionID, selectedValue) !== -1)
                    this.selectedDict[propertyID] = this.selectedDict[propertyID].filter(function (elem) { return elem != optionID; });
            }
        }
        else
        {
            $(option).addClass("is-selected");
            $(option).find("[type=checkbox]").prop("checked", true);
            // keep list of active filters
            var selectedValue = this.selectedDict[propertyID];
            if (typeof (selectedValue) != typeof (undefined))
            {
                if ($.inArray(optionID, selectedValue) == -1)
                    this.selectedDict[propertyID].push(optionID);
            }
            else
            {
                this.selectedDict[propertyID] = [];
                this.selectedDict[propertyID].push(optionID);
            }
        }

        this.updateNextStepButtonText();

        if (!onlyVisual && !selected)
        {
            var optionName = $(option).find('.js-option-name').text();

            sendDataLayer({
                'category': 'Keuzehulp',
                'action': this.wizardTitle.trim(),
                'label': optionName.trim(),
                'event': 'Click'
            });
        }

        this.selectWizardFilters(false, false);
    }

    private changeWizardStep = (itemStep) =>
    {
        const instance = this;
        var activeStep = this.getCurrentStep();

        if (!isNaN(activeStep))
        {
            $("#modal-wizard-modal button").off("click");
            instance.selectWizardFilters(false, true);

            // Previous step.
            if (itemStep < activeStep)
            {
                for (var i = activeStep; i >= itemStep; i--)
                {
                    var propertyID = $(`.wizard-step-item[data-order=${i + 1}]`).data("property-id");
                    var propertyIndex = instance.infoPassedProperties.indexOf(propertyID);
                    if (propertyIndex >= 0)
                        instance.infoPassedProperties.splice(propertyIndex, 1);
                }
            }
            // Next step.
            else if (itemStep > activeStep)
            {
                for (var i = activeStep; i < itemStep; i++)
                {
                    var propertyID = $(`.wizard-step-item[data-order=${i + 1}]`).data("property-id");
                    instance.infoPassedProperties.push(propertyID);
                }
            }

            var currentWizardID = this.getCurrentWizardID();

            this.updateDisabledOptions(function ()
            {
                instance.loadFilterWizardStep(currentWizardID, itemStep);
            });
        }
    };

    private handleWizardClick(option)
    {
        const instance = this;
        if ($(option).hasClass("disabled"))
            return;

        var optionID = $(option).data("option");

        // only trigger when double click happens on the same element
        if (this.filterPopupDoubleClick && this.filterPopupDoubleClickID == optionID)
        {
            this.filterPopupDoubleClick = false;
            clearTimeout(this.filterModalTimeout);

            // make sure it is selected
            if (!$(option).hasClass("is-selected"))
            {
                var propertyID = $(option).data("property");

                this.toggleWizardOption(option, propertyID, optionID, false);
            }

            if ($("#modal-wizard-modal .nextStep") && $("#modal-wizard-modal .nextStep").length > 0)
                $("#modal-wizard-modal .nextStep").trigger('click');
            else
            {
                $("#modal-wizard-modal button").off("click");

                this.selectWizardFilters(false, false);
                this.applyWizardFilters();
                this.close();
            }
        }
        else
        {
            this.filterPopupDoubleClick = true;
            this.filterPopupDoubleClickID = optionID;
           
            var propertyID = $(option).data("property");

            this.toggleWizardOption(option, propertyID, optionID, false);

            if ($(option).hasClass("is-selected"))
            {
                var selectedValue = this.deSelectedCheckBoxDict[propertyID];
                if (typeof (selectedValue) != typeof (undefined))
                {
                    if ($.inArray(optionID, selectedValue) !== -1)
                        this.deSelectedCheckBoxDict[propertyID] = this.deSelectedCheckBoxDict[propertyID].filter(function (elem) { return elem != optionID; });
                }
            }
            else
            {
                var selectedValue = this.deSelectedCheckBoxDict[propertyID];
                if (typeof (selectedValue) != typeof (undefined))
                {
                    if ($.inArray(optionID, selectedValue) == -1)
                        this.deSelectedCheckBoxDict[propertyID].push(optionID);
                }
                else
                {
                    this.deSelectedCheckBoxDict[propertyID] = [];
                    this.deSelectedCheckBoxDict[propertyID].push(optionID);
                }
            }

            this.filterModalTimeout = setTimeout(function ()
            {
                instance.filterPopupDoubleClick = false;
                instance.filterPopupDoubleClickID = 0;
            }, 250);
        }
    }

    private selectWizardFilters = (addTrackable, loadingDifferentStep) =>
    {
        const instance = this;
        var trackableFound = false;
        var trackableOverrideFound = false;

        if (!instance.infoFilterOptions)
            instance.infoFilterOptions = new Array();

        if (!addTrackable)
        {
            trackableFound = true;
            trackableOverrideFound = true;
        }

        var callQueryString = '';
        var activeProperties = [];
        var trackableUrl = '';
        var currentHash = '';

        if (this.buildWizard.length > 0)
        {
            var parts = this.buildWizard.split('#');
            trackableUrl = parts[0];

            if (parts.length > 1)
                currentHash = parts[1];
        }
        else
        {
            var tmpUrl = document.location.pathname + document.location.hash;

            var priceFilterString = "";
            var documentSearch = document.location.search.split("&");

            // Get location.search items and loop them to get the price filters if present.
            if (typeof documentSearch !== "undefined" && documentSearch != null && documentSearch.length > 0)
            {
                // Only get price filters from location.search.
                var priceFilters = $.grep(documentSearch, function (searchPriceFilters) { return searchPriceFilters.toLowerCase().indexOf("price-") >= 0 });

                if (typeof priceFilters !== "undefined" && priceFilters != null && priceFilters.length > 0)
                {
                    // Rebuild location.search to only contain price filters.
                    $(priceFilters).each(function (index, priceFilterItem)
                    {
                        if (priceFilterString.length <= 0)
                        {
                            if (priceFilterItem.indexOf("?") < 0)
                                priceFilterString = "?" + priceFilterItem;
                            else if (!Array.isArray(priceFilterItem))
                                priceFilterString = priceFilterItem;
                            else
                                priceFilterString = priceFilterItem[0];
                        }
                        else
                            // Append price filter.
                            priceFilterString += "&" + priceFilterItem;
                    });
                }
            }

            this.buildWizardPrice = priceFilterString;

            var parts = tmpUrl.split('#');
            trackableUrl = parts[0];

            if (parts.length > 1)
                currentHash = parts[1];
        }

        var currentOptions = new Array();

        var trackableOptions = new Array();

        var newHash = '';
        var propertyID = 0;
        var newOptions = new Array();

        // Don't check active options if loading a previous step, as at this point the active option selection is gone.
        if (!loadingDifferentStep)
        {
            $(".c-filterwizard__option, .c-filterwizard-option--image, .c-filterwizard-option__color").each(function ()
            {
                var option = $(this);
                var selected = $(option).hasClass("is-selected");

                propertyID = $(option).data("property");
                var optionID = $(option).data("option");

                if (selected)
                    newOptions.push(optionID);
            });
        }

        if (currentHash.length > 1)
        {
            if (currentHash.indexOf('#') == 0)
                currentHash = currentHash.substring(1);

            var propertiesSplit = currentHash.split('_');

            for (var i = 0; i < propertiesSplit.length; i++)
            {
                var optionSplit = propertiesSplit[i].split('-');
                var optionArray = new Array();
                var property = parseInt(optionSplit[0]);
                const optionvalue = parseInt(optionSplit[1]);

                if (!currentOptions[property])
                    currentOptions[property] = [];

                if (currentOptions[property]?.length > 0)
                    optionArray = currentOptions[property];

                optionArray.push(optionvalue);

                if (optionArray)
                    currentOptions[property] = optionArray;
            }
        }

        // Override current property if not loading previous step.
        if (!loadingDifferentStep)
            currentOptions[propertyID] = newOptions;

        // check if a trackable option was active before
        $(".filter-list-option input[type=checkbox]:checked").each(function (index, item)
        {
            var optionID = parseInt($(item).val() as string ?? "0") as number;
            var propertyID = parseInt($(item).closest(".filter-list-option").data("property-id"));

            // selected filter is not present we need to remove it from our base url.
            var filter = $("[data-id=chk-" + propertyID + "-" + optionID + "]");

            if (filter && filter.length > 0)
            {
                var link = $(filter).parent().find("a");
                var tmpUrl = '';

                if (link && link.length > 0)
                {
                    tmpUrl = link.attr("href");
                    var foundTrackable = '';

                    if (tmpUrl.length > 1 && tmpUrl.indexOf('#') <= -1)
                        foundTrackable = tmpUrl;
                    else if (tmpUrl.length > 1 && tmpUrl != '#')
                    {
                        // remove the hash if present
                        if (tmpUrl.indexOf('#') > 0)
                            foundTrackable = tmpUrl.split('#')[0];
                        else
                            foundTrackable = tmpUrl;
                    }

                    if (foundTrackable.length > 0)
                    {
                        var currentPath = document.location.pathname;
                        var trackablePart = currentPath.replace(foundTrackable, '');

                        var optionUrl = '';

                        // Only check selectedDict if current property is present in it.
                        var checkSelectedItems =
                            typeof (instance.selectedDict) !== typeof (undefined) &&
                            Object.keys(instance.selectedDict).length > 0 &&
                            typeof (instance.selectedDict[propertyID]) !== typeof (undefined) &&
                            instance.selectedDict[propertyID] != null;

                        var optionIsTrackable = true;


                        if (checkSelectedItems)
                            optionIsTrackable = instance.selectedDict[propertyID].indexOf(optionID) >= 0;

                        if (optionIsTrackable)
                        {
                            var urlPartsDistinct = true;

                            var foundTrackableParts = foundTrackable.split("/").filter(x => x);
                            var trackablePartParts = trackablePart.split("/").filter(x => x);

                            // Check if 'trackablePart' contains any part from 'foundTrackable'.
                            // If so, don't use both for 'optionUrl', as it would cause duplicate
                            // URL segments.
                            $(trackablePartParts).each(function (index)
                            {
                                if (foundTrackableParts.indexOf(trackablePartParts[0]) >= 0)
                                {
                                    urlPartsDistinct = false;
                                    return false;
                                }
                            });

                            if (urlPartsDistinct)
                            {
                                // Brand trackable part goes first.
                                if (propertyID == 16)
                                    optionUrl = trackablePart + foundTrackable;
                                else
                                    optionUrl = foundTrackable + trackablePart;
                            }
                            else
                                optionUrl = trackableUrl;

                            trackableOptions[optionID] = optionUrl;

                            trackableUrl = optionUrl;
                        }
                        else
                        {
                            // Remove trackable option.
                            currentOptions.splice(currentOptions.indexOf(propertyID));
                            trackableUrl = currentPath.replace(trackablePart, '');
                        }
                    }
                }
            }
        });

        var sortedArray = new Array();

        $(".wizard-step-item").each(function (index, item)
        {
            var propertyID = $(item).data('property-id');
            var priority = $(item).data('priority');

            sortedArray.push({
                'propertyID': propertyID,
                'priority': priority
            });
        });

        sortedArray.sort(function (a, b)
        {
            if (a.priority < b.priority)
                return -1;
            else if (a.priority > b.priority)
                return 1;
            else if (a.propertyID < b.propertyID)
                return -1;
            return 0;
        });

        $(sortedArray).each(function (index, item)
        {
            var propertyID = item.propertyID;

            if (currentOptions[propertyID] != null && currentOptions[propertyID].length > 0)
            {
                var value = currentOptions[propertyID];

                for (var i = 0; i < value.length; i++)
                {

                    var optionID = value[i];
                    var isTrackableOption = false;

                    if (!trackableFound)
                    {
                        // check for url
                        var filter = $("[data-id=chk-" + propertyID + "-" + optionID + "]");

                        if (filter && filter.length > 0)
                        {
                            var link = $(filter).parent().find("a");
                            var tmpUrl = '';

                            if (link && link.length > 0)
                            {
                                if (!filter.prop("checked"))
                                    tmpUrl = link.attr("href");

                                if (tmpUrl.length > 1 && tmpUrl != '#')
                                {
                                    if (trackableUrl.length < tmpUrl.length)
                                        trackableUrl = tmpUrl;

                                    isTrackableOption = true;
                                    trackableFound = true;
                                }
                                else if (!trackableOverrideFound && trackableOptions[optionID] !== undefined)
                                {
                                    if (trackableUrl.length < trackableOptions[optionID].length)
                                        trackableUrl = trackableOptions[optionID];

                                    isTrackableOption = true;
                                    trackableOverrideFound = true;
                                    trackableFound = true;
                                }
                            }
                        }
                    }
                    else if (!trackableOverrideFound && trackableOptions[optionID] !== undefined)
                    {
                        if (trackableUrl.length < trackableOptions[optionID].length)
                            trackableUrl = trackableOptions[optionID];

                        isTrackableOption = true;
                        trackableOverrideFound = true;
                    }

                    var optionInTrackableOptions = false;

                    if (typeof (trackableOptions[optionID]) !== typeof (undefined) &&
                        trackableOptions[optionID] != null &&
                        trackableOptions[optionID].length > 0
                    )
                        optionInTrackableOptions = true;

                    if (!isTrackableOption &&
                        !optionInTrackableOptions)
                    {
                        var newOption = propertyID + "-" + optionID;

                        if (newHash.length == 0)
                            newHash = "#" + newOption;
                        else
                            newHash += "_" + newOption;

                        callQueryString += '&property_' + propertyID + '=' + optionID;

                        var activePropArray = {};
                        activePropArray['property_' + propertyID] = "" + optionID + "";
                        activeProperties.push(activePropArray);

                        if (instance.infoFilterOptions[propertyID] == undefined)
                            instance.infoFilterOptions[propertyID] = new Array();

                        instance.infoFilterOptions[propertyID].push(optionID);
                    }
                }
            }
        });

        instance.buildWizard = trackableUrl + newHash;

        if (instance.filterInfoCall != null)
            instance.filterInfoCall.abort();

        var searchUrl = trackableUrl;

        if (searchUrl.length == 0)
            searchUrl = document.location.pathname;

        instance.infoFilterUrl = searchUrl;

        // Make sure to include filters that are not listed in the wizardfilter
        var activeFilters = getActiveFilters(true, false, false, false);

        if (typeof activeFilters !== typeof (undefined) && activeFilters != null && activeFilters.length > 0)
        {
            $(activeFilters).each(function (index, value)
            {
                var filterItem = activeFilters[index][0];
                var filterValue = activeFilters[index][1];

                // Check if not already listen in wizard filter
                if (typeof (currentOptions[filterItem]) === typeof (undefined))
                {
                    var newProperty = "&property_" + filterItem + "=" + filterValue;

                    if (!callQueryString.includes(newProperty))
                    {
                        callQueryString += newProperty;
                        var activePropArray = {};
                        activePropArray['property_' + filterItem] = "" + filterValue + "";
                        activeProperties.push(activePropArray);
                    }
                }
            });
        }

        var priceFilters = getActiveFilters(false, false, true, false) as string[];

        if (typeof priceFilters !== typeof (undefined) && priceFilters != null && priceFilters.length > 0)
        {
            $(priceFilters).each(function (index, value)
            {
                var priceFilterItem = priceFilters[index][0];
                var priceFilterValue = priceFilters[index][1];

                callQueryString += "&" + priceFilterItem + "=" + priceFilterValue;
                var activePropArray = {};
                activePropArray[priceFilterItem] = "" + priceFilterValue + "";
                activeProperties.push(activePropArray);
            });
        }

        var callback = function (data, statusText, jqXHR)
        {
            if (data.d !== undefined)
                instance.filterResultCount = parseInt(data.d);
            else if (data !== undefined)
                instance.filterResultCount = parseInt(data);

            var resultText = String.format(getTranslations().filterResultText, instance.filterResultCount);

            if ($("#modal-wizard-modal .g-popup__footer-buttons .nextStep").hasClass("show-results"))
            {
                var arrow = $("#modal-wizard-modal .g-popup__footer-buttons .nextStep span").clone();
                $(".nextStep").show();
                $(".nextStep").text(resultText);
                $("#modal-wizard-modal .g-popup__footer-buttons .nextStep").append(arrow);
            }
            else
            {
                $(".show-results-holder").show();
                $(".show-results").show();
                $(".show-results").text(resultText);
            }
        };

        if (callQueryString.length > 0)
        {
            if (shopConfig().api.active)
                sendApiCall({ endpoint: '/Filter/GetFilterResultCount', shopMode: 'Search', rawUrl: location.pathname, qsDictionary: activeProperties, callback: callback });
            else
            {
                var url = "/Services/Modules/Webshop.asmx/GetFilterResultCount?url=" + searchUrl + callQueryString;

                instance.filterInfoCall = $.ajax({
                    type: "POST",
                    url: url,
                    contentType: "application/json; charset=utf-8",
                    dataType: "json",
                    success: callback
                });
            }
        }
        else
        {
            instance.filterResultCount = 0;
            var resultText = getTranslations().txtFilterShowAllResult;
            $(".show-results-holder").hide();
            $(".show-results").hide();
            if ($("#modal-wizard-modal .g-popup__footer-buttons .nextStep").hasClass("show-results")) {
                var arrow = $("#modal-wizard-modal .g-popup__footer-buttons .nextStep span").clone();
                $(".nextStep").show();
                $(".nextStep").text(resultText);
                $("#modal-wizard-modal .g-popup__footer-buttons .nextStep").append(arrow);
            }
        }
    }

    private updateDisabledOptions = (callBack) =>
    {
        const instance = this;
        if (this.infoFilterUrl != null)
        {
            var callQueryString = '';

            $(instance.infoFilterOptions).each(function (propertyID, items)
            {
                if (items !== undefined)
                {
                    if (instance.infoPassedProperties.includes(propertyID))
                    {
                        $(items).each(function (index, optionID)
                        {
                            callQueryString += '&property_' + propertyID + '=' + optionID;
                        });
                    }
                }
            });

            var searchUrl = this.infoFilterUrl + callQueryString;

            if (searchUrl.length > 1)
            {
                const url = "/Services/Modules/Webshop.asmx/GetFilterResultOptions?url=" + searchUrl;

                instance.filterInfoCall = $.ajax({
                    type: "POST",
                    url: url,
                    contentType: "application/json; charset=utf-8",
                    dataType: "json",
                    success: function (data, statusText, jqXHR)
                    {
                        instance.currentResultOptions = data.d;

                        if (callBack !== undefined)
                            callBack();
                    }
                });
            }
        }
        else if (callBack !== undefined)
            callBack();
    };

    private checkWizardStepButtons = () =>
    {
        const instance = this;
        var activeStep = this.getCurrentStep();
        var nextWizardStep = this.getNextStep();
        var maxStep = $(".wizard-step-item").length - 1;

        if (!isNaN(activeStep) &&
            !isNaN(maxStep))
        {
            if ($("#modal-wizard-modal .previousStep").length > 0 &&
                activeStep <= 0
            )
                $("#modal-wizard-modal .previousStep").hide();
            else
                $("#modal-wizard-modal .previousStep").show();

            if ($("#modal-wizard-modal .nextStep").length > 0 &&
                !isNaN(nextWizardStep) &&
                nextWizardStep <= 0)
            {
                var text = $("#modal-wizard-modal .g-popup__footer-buttons .show-results").text();
                $("#modal-wizard-modal .show-results").hide();
                $("#modal-wizard-modal .g-popup__footer-buttons .nextStep").text(text);

                $("#modal-wizard-modal .nextStep").addClass("show-results");

                $("#modal-wizard-modal .nextStep").on("click", function ()
                {
                    $("#modal-wizard-modal button").off("click");
                    instance.selectWizardFilters(true, false);
                    instance.applyWizardFilters();
                    instance.close();
                });
            }
            else
            {
                $("#modal-wizard-modal .nextStep").removeClass("show-results");
                $("#modal-wizard-modal .nextStep").show();
                instance.updateNextStepButtonText();

                $("#modal-wizard-modal .nextStep").off().on("click", function ()
                {
                    new loaderIconButton({ button: this as HTMLButtonElement }).show();
                    instance.changeWizardStep(nextWizardStep);
                });
            }
        }
    }

    private updateNextStepButtonText = () =>
    {
        if (!$("#modal-wizard-modal .g-popup__footer-buttons .nextStep").hasClass("show-results"))
        {
            if ($(".c-filterwizard__options").find(".is-selected").length >= 1)
                $("#modal-wizard-modal .g-popup__footer-buttons .nextStep").text(getTranslations().txtNext);
            else
                $("#modal-wizard-modal .g-popup__footer-buttons .nextStep").text(getTranslations().txtSkip);
        }
    }

    public checkFilterWizardComplete(): void
    {
        const $wizardBlock = $(".js-filter-wizard");

        if ($wizardBlock.length > 0)
        {
            const wizardProperties = $wizardBlock.data("properties");
            const currentFilterProperties = getActiveFilters(true, false, false, false);

            let wizardPropertiesArray: string[] = [];
            let currentFilterPropertiesArray: string[] = [];

            if (wizardProperties != null && wizardProperties.length > 0)
                wizardPropertiesArray = wizardProperties.split(",");

            if (currentFilterProperties != null && currentFilterProperties.length > 0)
            {
                currentFilterPropertiesArray = currentFilterProperties
                    .map((x: any) => String(x[0]))
                    .filter((value: string, index: number, self: string[]) => self.indexOf(value) === index);
            }

            let filterWizardComplete = false;

            if (wizardPropertiesArray.length > 0 && currentFilterPropertiesArray.length > 0)
            {
                // Count as complete if every step has been filled.
                filterWizardComplete = wizardPropertiesArray.every(propertyID => currentFilterPropertiesArray.includes(propertyID));
            }

            // Check whether filter wizard options have all been filled, and change background colour based on result.
            if (filterWizardComplete)
                $wizardBlock.addClass("filter-wizard-complete");
            else
                $wizardBlock.removeClass("filter-wizard-complete");
        }
    }

    public show(id?: string)
    {        
        if (this.popup)
            this.popup.show();
    }

    public close = () =>
    {
        this.popup.hide();
    }
}